import { isObject } from 'lodash'

const oja = document.getElementById('oja-area')
const filesEndpoint = oja.getAttribute('data-files-endpoint')
const atcAjaxAction = oja.getAttribute('data-atc-ajax-action')
const productsEndpoint = oja.getAttribute('data-products-endpoint')
const userId = oja.getAttribute('data-user-id')

// @formatter:off
let config = {
  pusherKey: process.env.MIX_PUSHER_APP_KEY || '',
  pusherCluster: process.env.MIX_PUSHER_APP_CLUSTER || '',
  uploadBaseUrl: filesEndpoint || 'https://files.photomart.com.au',
  uploadAuthorization:
    process.env.MIX_UPLOAD_AUTHORIZATION || 'fnzuhqmquppulauztcxywoywcwjqurnhbmiemzfv',
  backendBaseUrl: productsEndpoint || 'http://127.0.0.1:8001',
  backendAuthorization:
    process.env.MIX_BACK_END_AUTHORIZATION || '2UqX4t6i5vnwMWex3DZFq5HGZS5GVPW3M2SQdm82',
  atcAjaxAction: atcAjaxAction || 'chill_add_to_cart',
  userId: userId || null
}
// @formatter:on

if (
  Object.prototype.hasOwnProperty.call(window, 'orderJourneyConfig') &&
  isObject(window.orderJourneyConfig)
) {
  config = { ...config, ...window.orderJourneyConfig }
}

export default config
